
import { LoggedInComponentBase } from '@/components/base/loggedInComponentBase';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AssetCard extends LoggedInComponentBase {
  @Prop() blobUrl!: string;
  @Prop({ default: false }) isVideo!: boolean;
}
